<template>
    <div>
        <div :class="fieldClasses('companyName')">
            <label class="label">{{ translate("federation.billing.company_name") }}</label>
            <div class="control">
                <input
                    id="companyName"
                    v-model="model.companyName"
                    class="input"
                    type="text"
                    :placeholder="translate('federation.billing.company_name')"
                />
            </div>
            <p v-if="fieldError('companyName')" class="help is-danger">{{ fieldError("companyName") }}</p>
        </div>

        <div :class="fieldClasses('street')">
            <label class="label">{{ translate("federation.billing.street") }}</label>
            <div class="control">
                <input id="street" v-model="model.street" class="input" type="text" :placeholder="translate('federation.billing.street')" />
            </div>
            <p v-if="fieldError('street')" class="help is-danger">{{ fieldError("street") }}</p>
        </div>

        <div class="columns">
            <div class="column">
                <div :class="fieldClasses('city')">
                    <label class="label">{{ translate("federation.billing.city") }}</label>
                    <div class="control">
                        <input
                            id="city"
                            v-model="model.city"
                            class="input"
                            type="text"
                            :placeholder="translate('federation.billing.city')"
                        />
                    </div>
                    <p v-if="fieldError('city')" class="help is-danger">{{ fieldError("city") }}</p>
                </div>
            </div>
            <div class="column">
                <div :class="fieldClasses('postalCode')">
                    <label class="label">{{ translate("federation.billing.postal_code") }}</label>
                    <div class="control">
                        <input
                            id="postalCode"
                            v-model="model.postalCode"
                            class="input"
                            type="text"
                            :placeholder="translate('federation.billing.postal_code')"
                        />
                    </div>
                    <p v-if="fieldError('postalCode')" class="help is-danger">{{ fieldError("postalCode") }}</p>
                </div>
            </div>
        </div>

        <div :class="fieldClasses('country')">
            <label class="label">{{ translate("federation.billing.country") }}</label>
            <div class="control">
                <CountrySelect v-model="model.country" :dropdown-mode="'container'" />
            </div>
            <p v-if="fieldError('country')" class="help is-danger">{{ fieldError("country") }}</p>
        </div>

        <div :class="fieldClasses('taxId')">
            <label class="label">{{ translate("federation.billing.tax_id") }}</label>
            <div class="control">
                <input id="taxId" v-model="model.taxId" class="input" type="text" :placeholder="translate('federation.billing.tax_id')" />
            </div>
            <p v-if="fieldError('taxId')" class="help is-danger">{{ fieldError("taxId") }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { BillingDetails } from "../Api/federationsApi";
    import { translate } from "./translations";
    import CountrySelect from "./CountrySelect.vue";
    import { ValidationErrorsMap } from "./types";

    const model = defineModel<BillingDetails>({ required: true });

    const props = defineProps<{
        validationErrors?: ValidationErrorsMap;
    }>();

    function fieldError(field: string): string {
        return props.validationErrors?.[field]?.join(" ") ?? "";
    }

    function fieldClasses(field: string) {
        return {
            field: true,
            "has-error": !!fieldError(field),
        };
    }
</script>
